import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoCalificacion, TipoCalificacionProps } from '../../interfaces/catalogos/TipoCalificacionInterface';

export const TipoCalificaciones = () => {

    return new Promise<TipoCalificacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoCalificacion/', token)
            .then( ({ data } : { data : TipoCalificacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoCalificaciones = () => {

    return new Promise<TipoCalificacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoCalificacion/ObtenerTipoCalificaciones', token)
            .then( ({ data } : { data : TipoCalificacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoCalificacion = ( params: TipoCalificacionProps ) => {

    return new Promise<TipoCalificacionProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoCalificacion/Actualizar', params, token)
            .then( ({ data } : { data : TipoCalificacionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoCalificacion });
            });

        }

    });

}

export const AgregarTipoCalificacion = ( params: TipoCalificacionProps ) => {

    return new Promise<TipoCalificacionProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoCalificacion/Agregar', params, token)
            .then( ({ data } : { data : TipoCalificacionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoCalificacion });
            });

        }

    });

}
